import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import axios from "axios";
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAddOrderMutation, useGetAllCartsQuery, useGetCartQuery, useUpdateCartMutation, useUpdateChargerMutation, useUpdateHeadphoneMutation, useUpdatePhonecaseMutation, useUpdateSmartphoneMutation } from "../../features/fullApi";
import { clearCart, getTotals } from "../../features/slices/cartSlice";
import './checkout.css'
import { toast } from "react-hot-toast";
import { Alert } from "@mui/material";

const Checkout = ({addressDetails}) => {
  console.log("ADDRESS DETAILS", addressDetails)
  const navigate = useNavigate()
  const user = JSON.parse(localStorage.getItem('user'))
  window.scrollTo(0, 0);
  const dispatch = useDispatch()
  const cart = useSelector(state => state.cart)
  useEffect(() => {
    dispatch(getTotals())
  }, [])

  const [currentUserCart, setCurrentUserCart] = useState({})
 

let itemsArr = []

const [addOrder] = useAddOrderMutation()
const [updateSmartphone] = useUpdateSmartphoneMutation()
const [updateCharger] = useUpdateChargerMutation()
const [updateHeadphone] = useUpdateHeadphoneMutation()
const [updatePhonecase] = useUpdatePhonecaseMutation()
//const {data:cartsData, error:cartsError, isLoading:cartsIsLoading} = useGetAllCartsQuery();
const [updateCart] = useUpdateCartMutation()
const [cartz, setCartz] = useState([])
const {data: cartData, error: cartError, isLoading: cartIsLoading} = useGetCartQuery(user._id);

// useEffect(() => {
//   if(cartsData?.length>0) {
//     cartsData.map(cart => {
//       setCartz([...cartz, cart])
//       if(cart.userId === user?._id) {
//         setCurrentUserCart(cart)
//       } 
//       localStorage.setItem("allCarts", JSON.stringify(cartsData))
//     })
//     console.log("CURRENT USER CART", currentUserCart)
//   }
// }, [cartsData])

const updateQuantity = async () => {
  cart?.cartItems.map(item => {
  if(item.title.includes("Smartphone")) {
  updateSmartphone({_id: item._id, quantity: item.quantity - item.cartQuantity}, { 
    headers: {
      'Token': `Bearer ${item?.accessToken}`
    }
  }).then(() => handleClearCart()).catch()} else if(item.title.includes("Charger")) {
    updateCharger({_id: item._id, quantity: item.quantity - item.cartQuantity}, { 
      headers: {
        'Token': `Bearer ${item?.accessToken}`
      }
    }).then(() => handleClearCart()).catch()
  } else if(item.title.includes("Headphones")) {
    updateHeadphone({_id: item._id, quantity: item.quantity - item.cartQuantity}, { 
      headers: {
        'Token': `Bearer ${item?.accessToken}`
      }
    }).then(() => handleClearCart()).catch()
  } else if(item.title.includes("Phonecase")) {
    updatePhonecase({_id: item._id, quantity: item.quantity - item.cartQuantity}, { 
      headers: {
        'Token': `Bearer ${item?.accessToken}`
      }
    }).then(() => handleClearCart()).catch()
  }
  // .then(res =>
  //       {
  //       const allCarts = JSON.parse(localStorage.getItem("allCarts"))
  //       allCarts?.map(cartz => {
  //         cartz?.products?.map(product => {
  //           //daca s-a gasit o anomalie la un cos
  //           if((product?.productId === res.data._id) && (product.quantity > res.data.quantity)) {
  //             const currentProducts = cartz.products
  //             let newProducts = []
  //             currentProducts.map(prod => {
  //               if(prod.productId === res.data._id) {
  //                 console.log("FOUND THE PRODUCT IN ANOTHER CART")
  //                 //daca s-a gasit produsul respectiv
  //                 // newProducts.push({productId: prod._id, quantity: res.data.quantity})
  //                 // console.log("new product after found", newProducts)
  //                 // console.log("QUANTITY WE SET IT", res.data.quantity)
  //               } else {
  //                 console.log("PUSHING THE OTHER PRODUCTS")
  //                 newProducts.push({productId: prod.productId, quantity: prod.quantity})
  //               }

  //             })
  //             updateCart({_id: cartz._id, products: newProducts, isActive: false})
  //             .then(res => 
  //             {
  //               console.log("res", res)
  //             })
  //             .catch(err => console.log("err", err))
  //           }
  //         })

  //       })
  //       
  //     }).catch(err => {
  //   console.log("Error", err);
  // })
})
}



cart?.cartItems.map(item => {
  let itemObj = {
    name: item.title,
    desc: "item description",
    sku: item._id,
    unit_amount: {
      currency_code: "USD",
      value: String(item.price)
    },
    quantity: String(item.cartQuantity)
  }
  itemsArr.push(itemObj)
})


let cartItemsArr = []
cart?.cartItems.map(item => {
  let cartItemObject = {
    _id: item._id,
    quantity: item.cartQuantity
  }
  cartItemsArr.push(cartItemObject)
})

const cartTotalStringified = String(cart.cartTotalAmount)
   // creates a paypal order
 const createOrder = async (data, actions) => {
  console.log("CURRENT USER CART ON CREATE ORDER", currentUserCart)
  //! tre sa opresti pe create order daca cineva face o comanda in acelasi timp
      return actions.order.create({
        purchase_units: [
        {
            reference_id: "PUHF",
            description: "Some description",
    
            custom_id: "Something7364",
            soft_descriptor: "Great description 1",
            amount: {
                currency_code: "USD",
                value: cartTotalStringified,
                breakdown: {
                    item_total: {
                        currency_code: "USD",
                        value: cartTotalStringified
                    }
                }
            },
            items: itemsArr,
            shipping: {
              name: {
                full_name: addressDetails.name + " " +  addressDetails.surname
              },
              address: {
                address_line_1: addressDetails.street,
                address_line_2: addressDetails.country,
                admin_area_1: addressDetails.region,
                admin_area_2: addressDetails.city,
                postal_code: addressDetails.zipcode,
                country_code: addressDetails.countryCode,
              }
            }
        }
      ]
      });
};


const handleClearCart = () => {
  dispatch(clearCart())
  const currentProducts = JSON.parse(localStorage.getItem("cartItems"))
  updateCart({_id: cartData._id, products: currentProducts})
  .then(res => console.log("res", res))
  .catch(err => console.log("err", err))
}

// check Approval
const onApprove = (data, actions) => {
  console.log("CURRENT USER CART ON APPROVE", currentUserCart)
  console.log("ADDRESS DETAILS ON SETTING ORDER", addressDetails)
    return actions.order.capture()
    .then(function (details) {
      const { payer } = details;
      const data = addOrder({
        userId: user._id,
        products: cartItemsArr,
        amount: cart.cartTotalAmount,
        addressId: addressDetails.addressId
      },
      { 
        headers: {
          'Token': `Bearer ${user?.accessToken}`
        }
      }
      ).then(async res => {
        console.log("res is###", res)
        //here you should decrease quantity
        await updateQuantity();
        //check if other users have the same products in cart
       dispatch(clearCart())
       navigate(`/order/${res.data._id}`)
      })
      .catch(err => console.log(err))
    })
    .catch(err => {
      toast("Your cart items have been modified, please refresh cart 1")
      //navigate('/payment/error')
    });

};
//capture likely error
 
  return (
    <div id="paypalContainer">
             <>
              <h1>Paypal Checkout</h1>    
              <div>
                  <PayPalScriptProvider options={{ "client-id": "AYHy1Qpa6qxXbz6OVs9UFYOzmx2g2ILdZV7I9QwprgueL93asRdtXu3BU-y5iM-wgIt3RqbMB4u2v6Kc" }}>
                      <PayPalButtons 
                        style={{ 
                          layout: "horizontal", 
                          color: "silver", 
                          shape:"pill" }}
                        createOrder={createOrder}
                        onApprove={onApprove}/>
                  </PayPalScriptProvider>
              </div>
            </> 
  </div>
);
}
export default Checkout